import { CouplePatientAPI, listAllTherapistPatientsResponse } from "../../patient";

/**
 * The therapist's caseload a plan can be written for: their individual
 * patients (first 1000) and couples, loaded in parallel. Either failing rejects.
 */
export async function loadPlanCaseload(therapistId: string) {
  const [patientsRes, couplesRes] = await Promise.all([
    listAllTherapistPatientsResponse(therapistId),
    CouplePatientAPI.listByTherapist(therapistId),
  ]);
  return { patients: patientsRes.data.patients, couples: couplesRes.data };
}
